import React, { useState } from 'react';
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import styles from './DropdownGray.module.css';

interface DropdownGrayProps {
  selectedValues: string[];
  selectedValue: string;
  setSelectedValue: React.Dispatch<React.SetStateAction<string>>;
  defaultValue?: string;
}

const DropdownGray = ({ selectedValues, selectedValue, setSelectedValue, defaultValue }: DropdownGrayProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (value: React.SetStateAction<string>) => {
    setSelectedValue(value);
    setIsOpen(false);
  };

  return (
    <div className={styles.dropdownContainer}>
      <button
        type='button'
        className={styles.dropdownTrigger}
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedValue || defaultValue || "Escolha"}
        <span className={styles.icon}>{isOpen ? <FaAngleUp size={16} color='#595959' /> : <FaAngleDown size={16} color='#595959' />}</span>
      </button>

      {isOpen && (
        <div className={styles.dropdownMenu}>
          {selectedValues
            .filter((value) => value !== selectedValue) // Remove o valor selecionado
            .map((value, index) => (
              <div
                key={index}
                className={styles.dropdownItem}
                onClick={() => handleSelect(value)}
              >
                {value}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default DropdownGray;
